(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scp-exhaust-catalog"] && !Shopify.designMode) return;
  try {
    
  function initExhaustCatalogs() {
    document.querySelectorAll('[data-exhaust-catalog]').forEach(function (catalog) {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      var buttons = catalog.querySelectorAll('[data-exhaust-filter]');
      var cards = catalog.querySelectorAll('[data-exhaust-name]');
      var status = catalog.querySelector('[data-exhaust-count]');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var term = button.dataset.exhaustFilter;
          var visible = 0;
          buttons.forEach(function (item) { item.setAttribute('aria-pressed', String(item === button)); });
          cards.forEach(function (card) {
            var matches = !term || card.dataset.exhaustName.includes(term);
            card.hidden = !matches;
            if (matches) visible += 1;
          });
          status.textContent = visible + (visible === 1 ? ' exhaust' : ' exhausts') + (term ? ' for ' + button.textContent.trim() : '');
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initExhaustCatalogs);
  else initExhaustCatalogs();
  document.addEventListener('shopify:section:load', initExhaustCatalogs);

  } catch(e) { console.error(e); }
})();
})();
